import React from 'react';

export default function Footer() {
  return (
    <footer
      style={{ backgroundColor: '#14213D' }}
      className={'px-8 py-10 lg:px-36'}
    >
      <div className={'lg:py-5'}>
        <h3 className={'text-white text-3xl lg:text-4xl text-center'}>
          Never delay on a disbursement
        </h3>
      </div>
      <div
        className={
          'flex flex-col-reverse lg:flex-row justify-between items-start'
        }
      >
        <div className={'text-white p-3'}>
          <h3 className={'text-3xl font-bold'}>SmartRewards</h3>
          <div className={'mt-5'}>
            <p className={'text-base font-light'}>smartrewards@team.com</p>
            <p className={'text-base font-light'}>info@smartrewards.org</p>
            <p className={'text-base font-light'}>
              98B Drv. Lateef Obi str. Lekki, Lagos state. All Rights Reserved
            </p>
          </div>
        </div>
        {/* <div className={'flex flex-col lg:flex-row'}> */}
        <div className={'text-white p-3'}>
          <h3 className={'font-semibold text-xl'}>Links</h3>
          <div className={'mt-3'}>
            <p className={'text-base font-light'}>Social media</p>
            <p className={'text-base font-light'}>Contacts</p>
          </div>
        </div>
        <div className={'text-white lg:ml-5 p-3'}>
          <h3 className={'font-semibold text-xl'}>Company</h3>
          <div className={'mt-3'}>
            <p className={'text-base font-light'}>Privacy Policy</p>
            <p className={'text-base font-light'}>Terms & Conditions</p>
          </div>
        </div>
        {/* </div> */}
      </div>
    </footer>
  );
}
